import { OptionDto } from "@/dtos";
import { VehicleCompanyRole } from "@/helpers/types";

const vehicleCompanyRol = [
  { value: parseInt(VehicleCompanyRole.ADMINISTRATOR), label: 'ADMINISTRADOR' },
  { value: parseInt(VehicleCompanyRole.OWNER), label: 'PROPIETARIO' },
] as OptionDto[];

export const getVehicleCompanyRolOptions = (): OptionDto[] => {
  return vehicleCompanyRol;
}

export const getVehicleCompanyRol = (value: number): OptionDto => {
  return vehicleCompanyRol.find((x) => x.value == value) ?? vehicleCompanyRol[0];
}

export const getRolVehicleCompany = (value: number): VehicleCompanyRole => {
  switch (value) {
    case 1001:
      return VehicleCompanyRole.ADMINISTRATOR;
    case 1002:
      return VehicleCompanyRole.OWNER;
    case 1003:
      return VehicleCompanyRole.MONITOR;
    default:
      return VehicleCompanyRole.ADMINISTRATOR;
  }
}